module.exports = __webpack_public_path__ + "static/media/linkedin.bb7f555f.svg";